"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const document_1 = require("@powerednow/shared/constants/document");
const payment_1 = __importDefault(require("@powerednow/shared/constants/payment"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
// eslint-disable-next-line no-redeclare
class PaymentType extends complexData_1.default {
    static get allowedAssociations() {
        return {
            paymentTypeToCountry: {
                key: 'paymentTypeToCountry',
                instance: (0, modelLookup_1.complexFindModel)('PaymentTypeToCountry'),
                cascadeDelete: false,
                condition: {
                    paymenttype_id: this.Entity.getForeignFieldSymbols().id,
                },
            },
            paymentSetting: {
                key: 'paymentSetting',
                instance: (0, modelLookup_1.complexFindModel)('PaymentSetting'),
                single: true,
                condition: {
                    payment_id: this.Entity.getForeignFieldSymbols().id,
                },
            },
        };
    }
    async getAvailableCountryIds() {
        const allPaymentTypeToCountry = await this.getAllPaymentTypeToCountry();
        return allPaymentTypeToCountry.map(typeToCountry => typeToCountry.data.country_id);
    }
    async isValidForCountry(countryId) {
        const validCountries = await this.getAvailableCountryIds();
        return validCountries.includes(countryId);
    }
    async enabledForDocumentType(documentTypeId) {
        const settings = await this.getPaymentSetting();
        const fieldMap = {
            [document_1.TYPES_VALUES.EXPENSE]: 'enabled_expense',
            [document_1.TYPES_VALUES.SUPPLIER_INVOICE]: 'enabled_supplier',
        };
        const settingField = fieldMap[documentTypeId] ? fieldMap[documentTypeId] : 'enabled';
        return (await this.availableForDocumentType(documentTypeId)) && settings.data[settingField];
    }
    async availableForDocumentType(documentTypeId) {
        const fieldMap = {
            [document_1.TYPES_VALUES.EXPENSE]: 'is_expense',
            [document_1.TYPES_VALUES.SUPPLIER_INVOICE]: 'is_supplier',
        };
        const settingField = fieldMap[documentTypeId] ? fieldMap[documentTypeId] : 'is_sales';
        return this.data[settingField];
    }
    static isSumUpPayment(paymentTypeId) {
        return [payment_1.default.TYPES.SUMUP, payment_1.default.TYPES.SUMUP_ONLINE].includes(paymentTypeId);
    }
    async isEnabledForDocumentPaymentCategory(documentPaymentCategory) {
        const paymentSetting = await this.getPaymentSetting();
        const isAllowed = this.data[payment_1.default.DOCUMENT_PAYMENT_CATEGORY_TO_ALLOWED_PROPERTY[documentPaymentCategory]];
        return isAllowed && paymentSetting.isEnabledForDocumentPaymentCategory(documentPaymentCategory);
    }
}
PaymentType.Entity = entity_1.default;
PaymentType.modelProperties = modelProperties_1.default;
exports.default = PaymentType;
//# sourceMappingURL=../../../../src/models/paymentType/index.js.map